import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import TextCard from "../cards/TextCard";
import { useHistory } from "react-router-dom";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { CreateNewPaymentRequest } from "../../models/supplierPayment.model";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import { CreateNewPayment } from "../../services/supplierPayment.service";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
interface props {
  openModel: boolean;
  price: number;
  setOpenPaymentModal: any;
  formValues: CreateNewPaymentRequest;
}
export default function ModalSettlementPayment({
  openModel,
  price,
  setOpenPaymentModal,
  formValues,
}: props) {
  const [open, setOpen] = React.useState(openModel);
  const [description, setDescription] = React.useState<string>();
  const { mutate: CreateNewPaymentMutate } = useMutation(CreateNewPayment, {
    onSuccess: (data: boolean) => {
      if (data) {
        toast.success(" عملیات با موفقیت انجام شد.");
        handleClose();
        history.push("/settlement/settlementDuring");
      } else {
        handleClose();
      }
    },
  });
  const handleClose = () => {
    setOpen(false);
    setOpenPaymentModal(false);
  };
  const history = useHistory();
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);
  const handleChange = (e: any) => {
    setDescription(e.target.value);
  };
  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{ borderRadius: "6px" }}
          className="ModalCmp textCenter"
        >
          <Typography
            className="textCenter mTop30 mbottom20"
            style={{ color: "#757575", fontSize: "16px" }}
          >
            آیا از ثبت درخواست تسویه با مبلغ{" "}
            <span
              style={{ color: "#01AF43", fontSize: "16px", fontWeight: "bold" }}
            >
              "{price.toLocaleString("fa")} ریال"
            </span>{" "}
            اطمینان دارید؟
          </Typography>
          <Typography
            className="textCenter mTop30 mbottom20"
            style={{ color: "#757575", fontSize: "14px" }}
          >
            در صورت تایید،{" "}
            <b
              style={{ color: "#757575", fontSize: "14px", fontWeight: "bold" }}
            >
              امکان ثبت درخواست دیگری در طی روز جاری
            </b>{" "}
            <span>وجود نخواهد داشت.</span>
          </Typography>
          <MaterialTextFieldComponent
            className={"shadowTextField"}
            id="description"
            name="description"
            multiline
            label=" توضیحات"
            onChange={handleChange}
            rows={4}
            //   value={values.description || ""}
            placeHolder={" توضیحات"}
            sx={{
              "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                fontSize: 13,
                lineHeight: "2vh !important",
                height: "6vh !important",
              },

              "& .MuiInputBase-root": {
                height: "10vh !important",
              },
            }}
          />
          <Grid container spacing={2} columns={12} className="mTop10">
            <Grid xs={3}></Grid>
            <Grid xs={3} style={{ marginLeft: "2.5px" }}>
              {" "}
              <Button
                fullWidth
                className="btnForm SuccessDefault  mTop20"
                onClick={() => {
                  formValues.description = description!;
                  CreateNewPaymentMutate(formValues);
                }}
              >
                بله
              </Button>
            </Grid>
            <Grid xs={3} style={{ marginRight: "2.5px" }}>
              {" "}
              <Button
                fullWidth
                className="btnForm ComingBack  mTop20"
                onClick={handleClose}
              >
                خیر
              </Button>
            </Grid>
            <Grid xs={3}></Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
